import { systemApi } from "@ultrade/react-sdk";
import { PointsSettings } from "../../interfaces"

/** seting action types */
export const actionTypes = {
  SAVE_POINTS_SETTINGS: "SAVE_POINTS_SETTINGS",
  SHOW_POINTS_TAB: "SHOW_POINTS_TAB"
}
/*
 * Action creators for login
 */

// export const savePointsSettings = (data: PointsSettings) => (dispatch) => {

//   dispatch({
//     type: actionTypes.SAVE_POINTS_SETTINGS,
//     data: data
//   })
// }

export const showPointsTab = (data: boolean) => (dispatch) => {
  dispatch(systemApi.util.updateQueryData("getSocialSettings", undefined , draft => {
    draft.isShowUltradePoints = data;
  }));
}
